import src from "IMAGE";
export default { src, width: 197, height: 99, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAS0lEQVR42oXNTQqAIBRFYfe/tGgUpdEPFNQO8mnx7CQ2rwvf7MA1fE9N8p6jrojjQJwnznUprn2DpDkIgrQNYjuCs6/eFbfm4O/iAc4we1RAhKcKAAAAAElFTkSuQmCC"};
